import { FC, useMemo } from "react";
import { useField } from "formik";
import { MultiButtonSelector } from "src/components/ButtonSelector/MultiButtonSelector";
import { FormField } from ".";
import { IFormField, SetMultiSelectOptions } from "src/@types/form";

export const MultiButtonSelectorField: FC<IFormField> = ({
  id,
  className,
  label,
  options,
  fieldClassName,
  labelClassName,
  selectorClassName,
  errorClassName,
  ...props
}) => {
  const fieldId = id || props.name;

  const [{ value }, { error, touched }, { setValue }] = useField<string[]>(
    fieldId as string
  );

  const isShownError = Boolean((touched || value.length) && error);

  //CHANGE - temp
  const setActiveOptions: SetMultiSelectOptions = (options) => {
    const values = options.map((options) => options.value.toString());
    setValue(values);
  };

  //CHANGE - temp
  const activeOptions = useMemo(
    () => options.filter((option) => value.includes(option.value.toString())),
    [value, options]
  );

  return (
    <FormField
      className={fieldClassName}
      labelClassName={labelClassName}
      label={label}
      labelFor={fieldId as string}
      error={error}
      errorClassName={errorClassName}
      isShownError={isShownError}
    >
      <MultiButtonSelector
        className={className}
        selectorClassName={selectorClassName}
        options={options}
        activeOptions={activeOptions}
        setActiveOptions={setActiveOptions}
      />
    </FormField>
  );
};
